import { Cloudinary } from 'cloudinary-core'
import appConfig from '../config'

const cl = new Cloudinary({
  cloud_name: appConfig.CLOUDINARY_NAME,
  secure: true
})

const idToCloudinaryUrl = (publicId, options = {}) => {
  return cl.url(publicId, options)
}

export default idToCloudinaryUrl
